export default {
    entityKey: 'test-observations',
    basePath: '/test-observations',
    titles: {
        singular: 'Observation',
        plural: 'Observations'
    }
}
